import { useRecoilValue } from "recoil";
import { pubState } from "../../../../../../../../recoil/pub.atom";
import { MileagePageWrapper } from "../../../../style";
import { MileageMenuResponse } from "../../../../../../../../api/pub-product";
import { useEffect, useState } from "react";
import { MileageMenuListWrapper } from "../../style";
import { PubMemberDto } from "../../../../../../../../api/member";

interface MileageMenuListProps {
  allList: MileageMenuResponse[];
  setSelectMenus: (value: MileageMenuResponse[]) => void;
  selectMenus: MileageMenuResponse[];
  member: PubMemberDto | null;
}

const MileageMenuList = ({
  allList,
  setSelectMenus,
  selectMenus,
  member,
}: MileageMenuListProps) => {
  const pub = useRecoilValue(pubState);
  const size = 15;
  const [list, setList] = useState<MileageMenuResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    setTotalPage(Math.max(1, Math.ceil(allList.length / size)));
    setList(allList.slice((currentPage - 1) * size, currentPage * size));
  }, [allList, currentPage]);

  const onPageChange = async (nextPage: number) => {
    if (currentPage + nextPage <= 0) return;
    if (currentPage + nextPage > totalPage) return;
    setCurrentPage(currentPage + nextPage);
  };

  const handleSelect = (item: MileageMenuResponse) => {
    if (!member) return;

    setSelectMenus([...selectMenus, item]);
  };

  return (
    <MileageMenuListWrapper>
      <div className="item-wrapper">
        {list.map((item, index) => (
          <div className="item" onClick={() => handleSelect(item)} key={index}>
            <div className="name">{item.name}</div>
            <div className="price">({item.price.toLocaleString()})</div>
          </div>
        ))}
      </div>
      <MileagePageWrapper>
        <img
          src="image-web/solution/page-left.png"
          alt="arrow"
          onClick={() => onPageChange(-1)}
        />
        <div className="page">
          {currentPage} / {totalPage}
        </div>
        <img
          src="image-web/solution/page-right.png"
          alt="arrow"
          onClick={() => onPageChange(1)}
        />
      </MileagePageWrapper>
    </MileageMenuListWrapper>
  );
};

export default MileageMenuList;
